import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgreementComponent } from '../../components/agreement/agreement.component';
import { RateCardGridModule } from '../../components/rate-cards/rate-card-grid.module';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PostcodeMapsModule } from './postcode-maps.module';
import { ServiceFeeModule } from 'src/app/components/service-fee/service-fee.module';
import { PendingChangesGuard } from 'src/app/guards/pending-changes.guard';
import { PresetRateCardSelectorComponent } from '../../components/agreement/preset-rate-card-selector/preset-rate-card-selector.component';

const routes: Routes = [
  {
    path: '',
    component: AgreementComponent,
    data: { title: 'Agreement' },
    canDeactivate: [PendingChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgreementRoutingModule {}

@NgModule({
  imports: [
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    AgreementRoutingModule,
    RateCardGridModule,
    PostcodeMapsModule,
    ServiceFeeModule,
  ],
  providers: [PendingChangesGuard],
  declarations: [AgreementComponent, PresetRateCardSelectorComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AgreementModule {}
